import { callExternalApi } from "./external-api.service.ts";

export type BannerSeverity = "info" | "warning" | "error";
export type BannerDisplay = "banner" | "modal" | "both";

export interface Banner {
  id: string;
  message: string;
  title?: string;
  severity: BannerSeverity;
  // Absent when the row predates the field, or when the backend has not yet
  // been deployed with display support.
  display?: BannerDisplay;
  start_date?: string;
  end_date?: string;
  dismissible: boolean;
}

interface BannersResponse {
  banners: Banner[];
}

/**
 * Fetches the banners the backend considers active. This endpoint is public so
 * that downtime notices also render on the login screen.
 */
export const getBanners = async () => {
  const config = {
    url: `${process.env.REACT_APP_PFS_BASE_URL}/banners`,
    method: "GET",
    headers: {
      "content-type": "application/json",
    },
  };

  const { data, error } = await callExternalApi<BannersResponse>({ config });

  return {
    data: data?.banners || [],
    error,
  };
};
